// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ReactDnd = require("react-dnd");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");
let ReactDndHtml5Backend = require("react-dnd-html5-backend");
let ReactDndHtml5Backend$1 = require("react-dnd-html5-backend").default;
let ReactDndTouchBackend = require("react-dnd-touch-backend").default;

let isTouchDevice = (function isTouchDevice() {
    if (typeof window !== 'undefined') {
      return 'ontouchstart' in document.documentElement
    }
    return false
  });

let dragDropContext = ReactDnd.DragDropContext(isTouchDevice() ? ReactDndTouchBackend : ReactDndHtml5Backend$1);

let make = dragDropContext(param => JsxRuntime.jsx(JsxRuntime.Fragment, {
  children: param.children
}));

let DragDropContext = {
  make: make
};

let boxTarget = {
  drop: (props, monitor) => {
    let onChange = props.onChange;
    if (onChange == null) {
      return;
    } else {
      return onChange(monitor.getItem().files);
    }
  }
};

let makeDropTarget = ReactDnd.DropTarget([ReactDndHtml5Backend.NativeTypes.FILE], boxTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
}));

let make$1 = makeDropTarget(props => {
  let newrecord = {...props};
  return JsxRuntime.jsx("div", (newrecord.onChange = undefined, newrecord.className = TailwindMerge.twMerge([
    "border-2 border-dashed duration-150",
    Stdlib_Option.getOr(props.isOver, false) ? "border-tan-blue-500" : "border-zinc-300"
  ]), newrecord.ref = props.connectDropTarget, newrecord.children = Stdlib_Option.getOr(props.children, null), newrecord));
});

let DropArea = {
  make: make$1
};

exports.isTouchDevice = isTouchDevice;
exports.dragDropContext = dragDropContext;
exports.DragDropContext = DragDropContext;
exports.boxTarget = boxTarget;
exports.makeDropTarget = makeDropTarget;
exports.DropArea = DropArea;
/* dragDropContext Not a pure module */
